import * as yup from "yup";

export const initialValues = {
  assessmentName: "",
  role: "",
  jobLinkId: "",
  testLevel: "",
  expiryDate: "",
  startTime: "",
  durationHr: 0,
  durationMin: 0,
  scoreMin: 0,
  testQuestions: [
    {
      questionId: "",
      weightage: "",
    },
  ],
  randomise: false,
};

export const populateForm = (value) => {
  return {
    assessmentName: value.assessmentName,
    role: value.role,
    jobLinkId: value.jobLinkId,
    testLevel: value.testLevel,
    expiryDate: value.expiryDate,
    startTime: value.startTime,
    durationHr: value.durationHr,
    durationMin: value.durationMin,
    scoreMin: value.scoreMin,
    testQuestions: value.testQuestions?.map((testQuestion) => ({
      questionId: testQuestion.questionId,
      weightage: testQuestion.weightage,
    })),
    randomise: value.randomise,
  };
};

export const validationSchema = yup.object().shape({
  assessmentName: yup.string().required("Assessment Name is required."),
  role: yup.string().notRequired(),
  jobLinkId: yup.string().notRequired(),
  testLevel: yup.string().required("Test Level is required."),
  expiryDate: yup.string().required("Expiry Date is required."),
  startTime: yup.string().required("Start Time is required."),
  durationHr: yup.number().required("Duration Hours is required."),
  durationMin: yup.number().required("Duration Minutes is required."),
  scoreMin: yup.number().required("Minimum Score is required."),
  testQuestions: yup.array().of(
    yup.object().shape({
      questionId: yup.string().required("Question is required."),
      weightage: yup.number().required("Weightage is required."),
    })
  ),
  randomise: yup.boolean().notRequired(),
});

export const testLevels = {
  EntryLevel: "EntryLevel",
  Intermediate: "Intermediate",
  Expert: "Expert",
};

export const jassessmentsConstants = [
  {
    name: "Testpaper1",
    candidates: "1",
    completed: "10",
    expiry: "30 Dec 2024",
    upload: "Dec 10, 2024-10:00AM",
    questions: "10",
    email: "test@test.com",
    reports: "10",
    time: "1:30",
  },
  {
    name: "Testpaper3",
    candidates: "1",
    completed: "10",
    expiry: "30 Dec 2024",
    upload: "Dec 10, 2024-10:00AM",
    questions: "10",
    email: "test@test.com",
    reports: "10",
    time: "1:30",
  },
];
